export default __webpack_public_path__ + "static/media/logoNefroPlus.df9eb086.png";